import React from 'react';
import { Button, List } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';
import Drawer from 'components/Drawer';
import useFormatMessage from 'hooks/useFormatMessage';
import { getQuerySummary } from './FilterSegment';

const SEGMENTS_QUERY = gql`
  query Segments {
    segments {
      id
      title
      query
    }
  }
`;

const AddSegmentDrawer = ({ open, onSubmit, onCancel }) => {
  const { data, loading } = useQuery(SEGMENTS_QUERY, { skip: !open });
  const $t = useFormatMessage();
  return (
    <Drawer
      open={open}
      onCancel={onCancel}
      onOk={() => onSubmit('custom')}
      okLabel="Custom segment"
      title="Add segment"
      loading={loading}
    >
      <p>Select from predefined segments or create your own custom segment from scratch.</p>
      <List
        dataSource={data?.segments}
        renderItem={(segment) => (
          <List.Item actions={[<Button onClick={() => onSubmit({ title: segment.title, query: { combinator: 'and', rules: [{ field: 'segment', value: segment.id, operator: '=' }] } })}>Add</Button>]}>
            <List.Item.Meta
              title={segment.title}
              description={<div dangerouslySetInnerHTML={{ __html: getQuerySummary({ query: segment.query, segments: data?.segments, $t }) }} />}
            />
          </List.Item>
        )}
      />
    </Drawer>
  );
};

export default AddSegmentDrawer;
